@let clientAppHeaderTemplate = conversationType()?.clientAppHeaderTemplate;
@if (clientAppHeaderTemplate) {
  <div
    [innerHTML]="
      clientAppHeaderTemplate
        | handlebar
          : conversation()?.templateData?.clientHeader ?? undefined
          : $any(conversationType()?.conversationDataSchema)?.required
        | safeHtml
    "></div>
}
